import { useSearchDateShortcut } from '@/hooks/useSearch'
import type {
  CrudFormItem,
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { LiveKeywordForm, LiveKeywordRecord } from './live-keyword.service'

export const liveKeywordSearchItems: CrudSearchItem[] = [
  {
    label: '日期',
    prop: 'addTime',
    type: 'dateTimeRange',
    valueFormat: 'YYYY-MM-DD HH:mm:ss',
    startPlaceholder: '开始时间',
    endPlaceholder: '结束时间',
    shortcuts: useSearchDateShortcut(),
    disabledDate: (date) => date.getTime() > Date.now()
  }
]

export function createLiveKeywordFormItems(
  eventOptions: CrudSelectOption[],
  optionsLoading: boolean
): CrudFormItem<LiveKeywordForm>[] {
  return [
    {
      label: '关键词',
      prop: 'keyword',
      type: 'input',
      placeholder: '请输入关键词'
    },
    {
      label: '直播间',
      prop: 'eventsId',
      type: 'select',
      placeholder: optionsLoading ? '直播间加载中' : '请选择直播间',
      disabled: optionsLoading,
      options: eventOptions
    },
    {
      label: '时间范围',
      prop: 'addTime',
      type: 'slot',
      slot: 'timeRange'
    }
  ]
}

export function createLiveKeywordTableColumns(
  showActions: boolean
): CrudTableColumn<LiveKeywordRecord>[] {
  const columns: CrudTableColumn<LiveKeywordRecord>[] = [
    { prop: 'keyword', label: '关键词', minWidth: 100 },
    {
      prop: 'eventsId',
      label: '直播间',
      minWidth: 120,
      showOverflowTooltip: true
    },
    { prop: 'times', label: '时间段', minWidth: 150 },
    { prop: 'totalNum', label: '统计量', minWidth: 100 }
  ]

  if (showActions) {
    columns.push({
      label: '操作',
      slot: 'rowActions',
      width: 100,
      fixed: 'right'
    })
  }
  return columns
}
